<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="failureofjustice-kindleinterior-5-8-2016"></div>
<div class="calibre1" id="tc-101">
<div class="calibre1">
<p class="normal-242-0-override"><span class="no-style-override4"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal-242-0-override"><span><img alt="titlepage2.jpg" class="generated-style" src="Images/image00243.jpeg"/></span><span class="no-style-override4"><br class="calibre1"/></span></p>
<p class="calibre2" id="calibre_pb_8"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?e3a318c6